module.exports = "<img class=\"task__photo__img\" [src]=\"urlSanitized\" alt=\"photo\">"